<template>
  <v-img 
    style="position: relative"
    src="/gimc/storage/assets/masterhead.jpg?height=800"
    lazy-src="/gimc/storage/assets/masterhead.jpg?thumb=true"
    :height="scHeight" dark>
    
    <div class="overlay" />

    <div class="sign-container">
      <v-row
        style="height:100%"
        class="d-flex pa-4"
        :class="{
          'justify-center align-top': true
        }"
      >
        <v-sheet class="sign pa-4 thin text-center" xxxcolor="rgba(255, 255, 255, .66)" xxelevation="12">
          {{title}}
          <br/>
          <v-btn rounded color="#ef6758" class="call2action thin text-center pa-6 mt-6" :to="{path: '/nos-offres'}" style="color:white" >
            Démarrer mon projet
          </v-btn>
        </v-sheet>
      </v-row>
    </div>
  </v-img>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  computed: {
    ...mapGetters('strapiv2', ['title']),
    scHeight: function () {
      return window.innerHeight - (this.$vuetify.breakpoint.xsOnly ? 56 : 100)
    },
  }
}
</script>

<style scoped>

.overlay {
  /* background-color: rgba(0, 0, 0, 0.5); */
  width: 100%;
  height: 100%;
  position: absolute;
}

.sign-container {
  margin-top:5em;
  background-color: rgba(0, 0, 0, 0.2);
}

.sign {
  font-style: normal;
  font-size: 64px;
  line-height: 68px;
  text-align: right;
  /* color: #0b755f; */
  color: white;
  width:70%;
  height:fit-content;
  position:relative;
  text-shadow: 0 0 4px rgba(0, 0, 0, 1);
  background-color: rgba(0, 0, 0, 0);
  /* box-shadow: 0 0 10px rgba(0, 0, 0, 0.3); */
}

.logo {
  position:absolute;
  top:-50px;
  left:-23px;
  width: 150px;
  height: 150px;
}

@media (max-width: 1264px) {
  .sign {
    /* font-size: 70px;
    line-height: 75px; */
    width:90%
  }

  .logo {
    top: -34px;
    left: -12px;
    width: 100px;
    height: 100px;
  }
}

@media (max-width: 700px) {

  .sign-container {
    margin-top:4em;
  }

  .sign {
    font-size: 45px;
    line-height: 55px;
    width:90%;
  }

  .logo {
    top: -14px;
    left: -10px;
    width: 60px;
    height: 60px;
  }
}
</style>